<template>
    <rkm-area
        title="Unidade"
        type="fieldset"
    >
        <rkm-button
            @click="$refs.Modal.open()"
            color="primary"
            slot="trailing"
            small
            title="Adicionar unidade"
        >
            <rkm-icon icon="plus" />
        </rkm-button>

        <List :data="data" />

        <Modal
            :data="data"
            ref="Modal"
        />

    </rkm-area>
</template>

<script>

// Components.
import List from './List'
import Modal from './Modal'

export default {
    components: { List, Modal },
    props: {
        data: { type: Object, required: true },
    },
}
</script>